module.exports = __webpack_public_path__ + "static/media/product_flood_frequency.26865122.jpg";